var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QS-common-table',{attrs:{"columns":_vm.columns,"data":_vm.tableData,"pagination":false,"row-key":"receivableId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }